import { Reveal } from "./Reveal";

const PageHero = ({ overline, title, subtitle, image }) => (
  <section data-testid="page-hero" className="relative h-[60vh] min-h-[440px] flex items-end overflow-hidden">
    <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/85 via-forest-deep/40 to-forest-deep/10" />
    <div className="container-fl relative pb-16 md:pb-20">
      <Reveal>
        {overline && <p className="overline text-clay/90 mb-4">{overline}</p>}
        <h1 className="font-serif text-5xl md:text-7xl text-bone leading-[1.05] max-w-4xl">{title}</h1>
        {subtitle && <p className="mt-6 text-bone/80 text-lg max-w-2xl font-light">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
